module.exports = __webpack_public_path__ + "static/media/momo13.7b6c038b.jpg";